module.exports = [
  require('./maztica'),
  require('./mhair_jungle'),
  require('./mintarn'),
  require('./moonsea'),
  require('./moonshaes'),
  require('./mulhorand'),
  require('./murghom'),
]
